import { render, staticRenderFns } from "./footer-primary.vue?vue&type=template&id=e8b8a31a&scoped=true&"
import script from "./footer-primary.vue?vue&type=script&lang=js&"
export * from "./footer-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b8a31a",
  null
  
)

export default component.exports